<template>
  <div class='h100 h-scroll'>
    <ejs-grid ref='grid' height='calc(100% - 0px)' :dataSource='data' :columns='tableColumns' :allowPaging='true' :pageSettings='pageSettings'
              :allowReordering='true' :allowResizing='true' :allowExcelExport='true'>
    </ejs-grid>
  </div>
</template>

<script>

import { Reorder, Resize, Page, ExcelExport} from '@syncfusion/ej2-vue-grids';
export default {
  name: 'TsCommonTable',
  props: {
    tsUrl: {
      type: String,
      default() {
        return [];
      }
    },
  },
  props: {
    tableColumns: {
      type: Array,
      default() {
        return [];
      }
    },
  },
  data() {
    return {
      pageSettings: {
        pageSizes: [15,30,50,100],
        pageSize: 15
      },
      data: [
        {'name':'test','taskStatus':1},
        {'name':'test','taskStatus':1},
        {'name':'test','taskStatus':1},
        {'name':'test','taskStatus':1},
        {'name':'test','taskStatus':1},
        {'name':'test','taskStatus':1},
        {'name':'test','taskStatus':1},
        {'name':'test','taskStatus':1},
        {'name':'test','taskStatus':1},
        {'name':'test','taskStatus':1},
        {'name':'test','taskStatus':1},
        {'name':'test','taskStatus':1},
        {'name':'test','taskStatus':1},
        {'name':'test','taskStatus':1},
        {'name':'test','taskStatus':1},
        {'name':'test','taskStatus':1},
        {'name':'test','taskStatus':1},
        {'name':'test','taskStatus':1},
        {'name':'test','taskStatus':1},
        {'name':'test','taskStatus':1},
        {'name':'test','taskStatus':1},
        {'name':'test','taskStatus':1},
        {'name':'test','taskStatus':1},
        {'name':'test','taskStatus':1},
        {'name':'test','taskStatus':1},
        {'name':'test','taskStatus':1}
      ]
    };
  },
  provide: {
    grid: [Reorder, Resize, Page, ExcelExport]
  },
  mounted() {
  },
  methods: {
    queryData(qryParams) {

    },
    exportData() {
      if (this.data.length < 1) {
        EventBus.$emit('toast', {type: 'warning', content: this.$t('Track.noDataToExport')});
        return;
      }
      const exportProperties = {
        fileName: `${this.$t('Track.signalDataExport')}.xlsx`,
        dataSource: this.data,
        includeHiddenColumn: true
      };
      this.$refs.grid.excelExport(exportProperties);

    },
  }
};

</script>

<style scoped>

</style>
